module.exports = __webpack_public_path__ + "static/media/approach-construction.231a04a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/approach-construction.jpg
// module id = 138
// module chunks = 0